type App_Conf_Data = {
    API_URL: string;
    APIM_URL: string;
    APP_URL: string;
    PWS_URL: string;
    RELAY_ENDPOINT_URL: string;
    RELAY_FUNCTION_URL: string;
    RELAY_FUNCTION_URL_AKS: string;
    MEETING_PORTAL_AUTHENTICATOR_FN_URL: string;
    MEETING_PORTAL_AUTHENTICATOR_FN_URL_AKS: string;
    ACS_TEAMS_USER_TOKEN_PROVIDER_FN_URL: string;
    SPA_CONFIG_FN_URL: string;
    AUTHORITY: string;
    GOOGLE_ANALYTICS_ENV: string;
    PACING_USER_GROUP: string;
    NATIONAL_SAMPLE_ADMIN_GROUP: string;
    SPA_CONFIG_CLIENT_ID: string;
    SPA_CONFIG_SCOPES: string;
    SPA_CONFIG_MPA_INFO_URL_AKS: string;
};

enum Authorities {
    DEFAULT = "https://login.microsoftonline.com/2434528d-4270-4977-81dd-a6308c1761a3"
}

export enum LocationURIs {
    AZURE_DEV = "gpi.dev.northerntrust.com",
    AZURE_UAT = "gpi.uat.northerntrust.com",
    AZURE_QA = "gpi.qa.northerntrust.com",
    AZURE_QA_CUS = "gpi.cus.qa.northerntrust.com",
    AZURE_QA_EU2 = "gpi.eu2.qa.northerntrust.com",
    AZURE_PROD = "gpi.northerntrust.com",
    AZURE_PROD_CUS = "gpi.cus.northerntrust.com",
    AZURE_PROD_EU2 = "gpi.eu2.northerntrust.com",
    LOCAL = "localhost:8080",
}

const appUrl = window.location.origin;
const apimUrl = `${appUrl}/apim`;
const apiUrl = `${apimUrl}/gateway/v1/api`;
const pwsLinks = {
    nonProd: "https://ntrs--fulltwo.sandbox.file.force.com/",
    prod: "https://ntrs.lightning.force.com/lightning/page/home"
};

let app_conf: App_Conf_Data = {
    API_URL: apiUrl,
    APIM_URL: apimUrl,
    APP_URL: appUrl,
    PWS_URL: pwsLinks.nonProd,
    RELAY_FUNCTION_URL: '',
    RELAY_FUNCTION_URL_AKS: '',
    ACS_TEAMS_USER_TOKEN_PROVIDER_FN_URL: '',
    MEETING_PORTAL_AUTHENTICATOR_FN_URL: '',
    MEETING_PORTAL_AUTHENTICATOR_FN_URL_AKS: '',
    RELAY_ENDPOINT_URL: 'https://us.fluidrelay.azure.com',
    AUTHORITY: Authorities.DEFAULT,
    SPA_CONFIG_FN_URL: '',
    GOOGLE_ANALYTICS_ENV: '',
    PACING_USER_GROUP: '',
    NATIONAL_SAMPLE_ADMIN_GROUP: '',
    SPA_CONFIG_CLIENT_ID: '',
    SPA_CONFIG_SCOPES: '',
    SPA_CONFIG_MPA_INFO_URL_AKS: '',
}

const spa_config_dev = {
    SPA_CONFIG_CLIENT_ID: 'ecfc1937-ac34-4882-8e1d-86d3d790eb2e',
    SPA_CONFIG_SCOPES: 'api://gpidev.ntrs.com/GPI.Read openid profile OnlineMeetings.ReadWrite',
    SPA_CONFIG_MPA_INFO_URL_AKS: '/meeting/info',
}

const spa_config_uat = {
    SPA_CONFIG_CLIENT_ID: '15ee2361-cbe8-4cf7-a3c6-18ee0513aaf9',
    SPA_CONFIG_SCOPES: 'api://gpiuat.ntrs.com/GPI.Read openid profile OnlineMeetings.ReadWrite',
    SPA_CONFIG_MPA_INFO_URL_AKS: '/meeting/info',
}

const spa_config_qa = {
    SPA_CONFIG_CLIENT_ID: '15ee2361-cbe8-4cf7-a3c6-18ee0513aaf9',
    SPA_CONFIG_SCOPES: 'api://gpiuat.ntrs.com/GPI.Read openid profile OnlineMeetings.ReadWrite',
    SPA_CONFIG_MPA_INFO_URL_AKS: '/meeting/info',
}

const spa_config_prod = {
    SPA_CONFIG_CLIENT_ID: 'c7cf1e68-d9fd-454b-9a6d-79190953fb3a',
    SPA_CONFIG_SCOPES: 'api://gpi.ntrs.com/GPI.Read openid profile OnlineMeetings.ReadWrite',
    SPA_CONFIG_MPA_INFO_URL_AKS: '/meeting/info',
}

switch (window.location.host) {
    case LocationURIs.AZURE_PROD:
        console.log('Configuring Azure PRODAZ4 environment');
        app_conf = {
            ...app_conf,
            ...spa_config_prod,
            API_URL: `${app_conf.APIM_URL}/gatewayaks/v1/api`,
            MEETING_PORTAL_AUTHENTICATOR_FN_URL: `${app_conf.APIM_URL}/meetingaz/v1/api/MeetingPortalAuthenticatorHttpTrigger`,
            MEETING_PORTAL_AUTHENTICATOR_FN_URL_AKS: `/meeting-auth`,
            SPA_CONFIG_FN_URL: `${app_conf.APIM_URL}/spa-configaz/v1/api/SpaConfigHttpTrigger`,
            PWS_URL: pwsLinks.prod,
            GOOGLE_ANALYTICS_ENV: 'GDWM - PROD',
            PACING_USER_GROUP: 'GPI-A-P-PacingUsers',
            NATIONAL_SAMPLE_ADMIN_GROUP: 'GPI-A-P-AdminNationalSamples',
        };
        break;
    case LocationURIs.AZURE_PROD_CUS:
        console.log('Configuring Azure PRODAZ4_CUS environment');
        app_conf = {
            ...app_conf,
            ...spa_config_prod,
            API_URL: `${app_conf.APIM_URL}/gatewayaks/v1/api`,
            MEETING_PORTAL_AUTHENTICATOR_FN_URL: `${app_conf.APIM_URL}/meetingaz/v1/api/MeetingPortalAuthenticatorHttpTrigger`,
            MEETING_PORTAL_AUTHENTICATOR_FN_URL_AKS: `/meeting-auth`,
            SPA_CONFIG_FN_URL: `${app_conf.APIM_URL}/spa-configaz/v1/api/SpaConfigHttpTrigger`,
            PWS_URL: pwsLinks.prod,
            GOOGLE_ANALYTICS_ENV: 'GDWM - PROD',
            PACING_USER_GROUP: 'GPI-A-P-PacingUsers',
            NATIONAL_SAMPLE_ADMIN_GROUP: 'GPI-A-P-AdminNationalSamples',
        };
        break;
    case LocationURIs.AZURE_PROD_EU2:
        console.log('Configuring Azure PRODAZ4_EU2 environment')
        app_conf = {
            ...app_conf,
            ...spa_config_prod,
            API_URL: `${app_conf.APIM_URL}/gatewayaks/v1/api`,
            MEETING_PORTAL_AUTHENTICATOR_FN_URL: `${app_conf.APIM_URL}/meetingaz/v1/api/MeetingPortalAuthenticatorHttpTrigger`,
            MEETING_PORTAL_AUTHENTICATOR_FN_URL_AKS: `/meeting-auth`,
            SPA_CONFIG_FN_URL: `${app_conf.APIM_URL}/spa-configaz/v1/api/SpaConfigHttpTrigger`,
            PWS_URL: pwsLinks.prod,
            GOOGLE_ANALYTICS_ENV: 'GDWM - PROD',
            PACING_USER_GROUP: 'GPI-A-P-PacingUsers',
            NATIONAL_SAMPLE_ADMIN_GROUP: 'GPI-A-P-AdminNationalSamples',
        };
        break;
    case LocationURIs.AZURE_DEV:
        console.log('Configuring Azure DEVAZ4 environment');
        app_conf = {
            ...app_conf,
            ...spa_config_dev,
            API_URL: `${app_conf.APIM_URL}/gatewayaks/v1/api`,
            MEETING_PORTAL_AUTHENTICATOR_FN_URL: `${app_conf.APIM_URL}/meetingaz/v1/api/MeetingPortalAuthenticatorHttpTrigger`,
            MEETING_PORTAL_AUTHENTICATOR_FN_URL_AKS: `/meeting-auth`,
            SPA_CONFIG_FN_URL: `${app_conf.APIM_URL}/spa-configaz/v1/api/SpaConfigHttpTrigger`,
            PWS_URL: pwsLinks.nonProd,
            GOOGLE_ANALYTICS_ENV: 'GDWM - Dev',
            PACING_USER_GROUP: 'GPI-A-D-PacingUsers',
            NATIONAL_SAMPLE_ADMIN_GROUP: 'GPI-A-D-AdminNationalSamples',
        };
        break;
    case LocationURIs.AZURE_QA:
        console.log('Configuring Azure QAAZ4 environment')
        app_conf = {
            ...app_conf,
            ...spa_config_qa,
            API_URL: `${app_conf.APIM_URL}/gatewayaks/v1/api`,
            MEETING_PORTAL_AUTHENTICATOR_FN_URL: `${app_conf.APIM_URL}/meetingaz/v1/api/MeetingPortalAuthenticatorHttpTrigger`,
            MEETING_PORTAL_AUTHENTICATOR_FN_URL_AKS: `/meeting-auth`,
            SPA_CONFIG_FN_URL: `${app_conf.APIM_URL}/spa-configaz/v1/api/SpaConfigHttpTrigger`,
            PWS_URL: pwsLinks.nonProd,
            GOOGLE_ANALYTICS_ENV: 'GDWM - QA',
            PACING_USER_GROUP: 'GPI-A-U-PacingUsers',
            NATIONAL_SAMPLE_ADMIN_GROUP: 'GPI-A-U-AdminNationalSamples',
        };
        break;
    case LocationURIs.AZURE_QA_CUS:
        console.log('Configuring Azure QAAZ4_CUS environment')
        app_conf = {
            ...app_conf,
            ...spa_config_qa,
            API_URL: `${app_conf.APIM_URL}/gatewayaks/v1/api`,
            MEETING_PORTAL_AUTHENTICATOR_FN_URL: `${app_conf.APIM_URL}/meetingaz/v1/api/MeetingPortalAuthenticatorHttpTrigger`,
            MEETING_PORTAL_AUTHENTICATOR_FN_URL_AKS: `/meeting-auth`,
            SPA_CONFIG_FN_URL: `${app_conf.APIM_URL}/spa-configaz/v1/api/SpaConfigHttpTrigger`,
            PWS_URL: pwsLinks.nonProd,
            GOOGLE_ANALYTICS_ENV: 'GDWM - QA',
            PACING_USER_GROUP: 'GPI-A-U-PacingUsers',
            NATIONAL_SAMPLE_ADMIN_GROUP: 'GPI-A-U-AdminNationalSamples',
        };
        break;
    case LocationURIs.AZURE_QA_EU2:
        console.log('Configuring Azure QAAZ4 EU2 environment')
        app_conf = {
            ...app_conf,
            ...spa_config_qa,
            API_URL: `${app_conf.APIM_URL}/gatewayaks/v1/api`,
            MEETING_PORTAL_AUTHENTICATOR_FN_URL: `${app_conf.APIM_URL}/meetingaz/v1/api/MeetingPortalAuthenticatorHttpTrigger`,
            MEETING_PORTAL_AUTHENTICATOR_FN_URL_AKS: `/meeting-auth`,
            SPA_CONFIG_FN_URL: `${app_conf.APIM_URL}/spa-configaz/v1/api/SpaConfigHttpTrigger`,
            PWS_URL: pwsLinks.nonProd,
            GOOGLE_ANALYTICS_ENV: 'GDWM - QA',
            PACING_USER_GROUP: 'GPI-A-U-PacingUsers',
            NATIONAL_SAMPLE_ADMIN_GROUP: 'GPI-A-U-AdminNationalSamples',
        };
        break;
    case LocationURIs.AZURE_UAT:
        console.log('Configuring Azure UATAZ4 environment')
        app_conf = {
            ...app_conf,
            ...spa_config_uat,
            API_URL: `${app_conf.APIM_URL}/gatewayaks/v1/api`,
            MEETING_PORTAL_AUTHENTICATOR_FN_URL: `${app_conf.APIM_URL}/meetingaz/v1/api/MeetingPortalAuthenticatorHttpTrigger`,
            MEETING_PORTAL_AUTHENTICATOR_FN_URL_AKS: `/meeting-auth`,
            SPA_CONFIG_FN_URL: `${app_conf.APIM_URL}/spa-configaz/v1/api/SpaConfigHttpTrigger`,
            PWS_URL: pwsLinks.nonProd,
            GOOGLE_ANALYTICS_ENV: 'GDWM - UAT',
            PACING_USER_GROUP: 'GPI-A-U-PacingUsers',
            NATIONAL_SAMPLE_ADMIN_GROUP: 'GPI-A-U-AdminNationalSamples',
        };
        break;
    default:
        app_conf = {
            ...app_conf,
            ...spa_config_dev,
            API_URL: 'http://localhost:8081',
            RELAY_FUNCTION_URL: 'https://gpi-fluid-token-provider-cus-d-az4funcapp.azurewebsites.net/api/FluidTokenProviderHttpTrigger?code=-xQmZP92LW_3uErgQn_2F09TvBETQveO_lXVC1Efzj_XAzFuF8gkTA==',
            RELAY_FUNCTION_URL_AKS: 'https://services.cus.dev.gpi.aks.ntrs.com/fluid-token',
            MEETING_PORTAL_AUTHENTICATOR_FN_URL: 'https://gpi-meeting-authenticator-cus-d-az4funcapp.azurewebsites.net/api/MeetingPortalAuthenticatorHttpTrigger?',
            MEETING_PORTAL_AUTHENTICATOR_FN_URL_AKS: '/meeting-auth',
            ACS_TEAMS_USER_TOKEN_PROVIDER_FN_URL: 'https://gpi-fluid-token-provider-cus-d-az4funcapp.azurewebsites.net/api/ACSTeamsUserTokenProviderHttpTrigger?',
            SPA_CONFIG_FN_URL: 'https://gpi-spa-config-cus-d-az4funcapp.azurewebsites.net/api/SpaConfigHttpTrigger',
            PWS_URL: pwsLinks.nonProd,
            PACING_USER_GROUP: 'GPI-A-D-PacingUsers',
            NATIONAL_SAMPLE_ADMIN_GROUP: 'GPI-A-D-AdminNationalSamples',
        };
        break;
}

if (process.env.REACT_APP_API_URL !== undefined) {
    console.log('Reconfiguring API_URL to:');
    console.log(process.env.REACT_APP_API_URL);
    app_conf = {...app_conf, API_URL: process.env.REACT_APP_API_URL};
}

if (window.location.host !== LocationURIs.LOCAL) {
    app_conf = {
        ...app_conf,
        RELAY_FUNCTION_URL: `${app_conf.API_URL}/FluidTokenProviderHttpTrigger`,
        RELAY_FUNCTION_URL_AKS: `${app_conf.API_URL}/fluid-token`,
        ACS_TEAMS_USER_TOKEN_PROVIDER_FN_URL: `${app_conf.API_URL}/ACSTeamsUserTokenProviderHttpTrigger`,
    }
}

export const isLocalGateway = () => {
    return app_conf.API_URL === 'http://localhost:8081';
};

export const App_Conf = app_conf;
